import React from 'react';
import state from '../zviz3/state';
import {ConnectState} from '../zviz3/Connect';
import Button from './button';
import Explanation from './explanation';
import {checkConditions} from '../helpers/conditions';

class Question extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            showExplanation: false,
            value: state.get('answers.' + props.name)
        }

        this.selectValue = this.selectValue.bind(this);

    }

    componentDidUpdate(){
        if(! this.showQuestion() && this.state.value !== null){
            this.selectValue(null);
        }
    }

    getExplanation(){
        if(! this.props.explanation){
            return '';
        }

        return <Explanation text={this.props.explanation} id={this.props.name} />;
    }

    getButtons(){
        let result = [];
        for(const option of this.props.options){
            result.push(<Button 
                key={option.value} 
                value={option.value} 
                label={option.label} 
                onSelect={this.selectValue}
                isAnswered={! this.props.multiselect && this.state.value!==null}
                isSelected={this.props.multiselect && this.state.value? 
                    this.state.value.indexOf(option.value) !== -1:
                    this.state.value === option.value}
            />);
        }
        return result;
    }

    selectValue(value){
        if(this.props.multiselect){
            if(value !== null){
                const val = this.state.value? this.state.value.slice(): [];

                if(val.indexOf(value) === -1){
                    val.push(value);
                }else{
                    val.splice(val.indexOf(value), 1);
                }
                value = val;
            }
        }else if(this.state.value === value){
            value = null;   // was already selected, now deselect
        }

        this.setState({
            value: value
        });

        if(this.props.multiselect && (! value || value.length < this.props.minSelect)){
            state.set('answers.' +this.props.name, null);
        }else{
            state.set('answers.' +this.props.name, value);
        }
    }

    showQuestion(){
        if(this.props.conditions.length === 0){
            return true;
        }
        return checkConditions(this.props.conditions);
    }

    getQuestion(){
        return typeof this.props.question === 'function'? this.props.question(): this.props.question;

    }

    render(){
        if(! this.showQuestion()){
            return '';
        }

        return <div className="seehi_question">
            <div className="seehi_innerQuestion">
                <p>{this.getQuestion()}</p>
            </div>            
            {this.getExplanation()}
            <div className="seehi_innerQuestion">
                {this.getButtons().map((i) => (i))}
            </div>
        </div>
    }

}

Question.defaultProps = {
    name: 'question',
    question: 'Are you a space cowboy?',
    explanation: 'Do you go into space waving around a lasso, answer yes. If not answer no.',
    multiselect: false,
    minSelect: 1,
    options: [
        {value: true, label: 'Yes'},
        {value: false, label: 'No'}
    ],
    conditions: [
        {variable: '', value: '', type: 'equal'}
    ]
}

export default ConnectState(Question, 'answers');


// WEBPACK FOOTER //
// ./src/elements/question.js